import {
  CustomerDetails,
  RegistrationApplianceDetails,
  RegistrationSource,
  RegistrationSystemCode,
  RegistriaUserRequest,
} from '@us-registration/util-models';

export function formatRegistriaRequest(
  source: RegistrationSource,
  customerDetails?: CustomerDetails,
  appliance?: RegistrationApplianceDetails,
  token?: string,
  locale?: string
): RegistriaUserRequest | undefined {
  if (!appliance || !customerDetails) {
    return;
  }

  return {
    user: {
      address: {
        address1: customerDetails.billingAddress.line1,
        address2: customerDetails.billingAddress.line2,
        city: customerDetails.billingAddress.city,
        country: customerDetails.billingAddress.country,
        state: customerDetails.billingAddress.state,
        zip: customerDetails.billingAddress.postalCode,
      },
      email: customerDetails.email,
      first_name: customerDetails.firstName,
      last_name: customerDetails.lastName,
      phone: customerDetails.phone.Home,
      locale,
      token,
      source,
    },
    registration: {
      product_sku: appliance.modelNumber,
      serial_number: appliance.serialNumber,
      purchase_date: appliance.purchaseDate,
      brand: appliance.brand.toLowerCase(),
      source,
    },
  };
}

export function determineRegistrationSourceFromRegistrationSystemCode(
  registrationSystemCode: RegistrationSystemCode
): RegistrationSource {
  const mapping: Record<RegistrationSystemCode, RegistrationSource> = {
    [RegistrationSystemCode.InternetProductRegistration]:
      RegistrationSource.WEB,
    [RegistrationSystemCode.PhotoregProductRegistration]: RegistrationSource.PR,
    [RegistrationSystemCode.QRCodeProductRegistration]: RegistrationSource.QR,
  };

  return mapping[registrationSystemCode];
}
